import { ticketImages } from '@/assets/img/lottery';
import {
  type PaidSpecContractType,
  type SpecContractType,
} from '@/common/types/contract';

import cashPng from '/img/icons/cash-large.png';
import cashWebp from '/img/icons/cash-large.webp';
import customizablePng from '/img/icons/custom_contract/customizable.png';
import customizableWebp from '/img/icons/custom_contract/customizable.webp';
import dicePng from '/img/icons/dice.png';
import diceWebp from '/img/icons/dice.webp';
import starPng from '/img/icons/star-large.png';
import starWebp from '/img/icons/star-large.webp';

type Benefit = {
  id: string;
  icon: { img: string; webp: string; alt: string };
  additionalText?: string;
  description: string;
};

const makeBaseBenefits = (bonus: string): Benefit[] => [
  {
    id: '1',
    icon: { img: cashPng, webp: cashWebp, alt: 'cash' },
    additionalText: bonus,
    description: 'CASH',
  },
  {
    id: '2',
    icon: { img: starPng, webp: starWebp, alt: 'points' },
    additionalText: bonus,
    description: 'Star Points',
  },
  {
    id: '3',
    icon: { img: dicePng, webp: diceWebp, alt: 'dice' },
    description: 'Dice in rewards',
  },
];

const silverTicketBenefit: Benefit = {
  id: '4',
  icon: {
    img: ticketImages.silver.png,
    webp: ticketImages.silver.webp,
    alt: 'silver ticket',
  },
  description: 'Silver Ticket in rewards',
};

const goldTicketBenefit: Benefit = {
  id: '4',
  icon: {
    img: ticketImages.gold.png,
    webp: ticketImages.gold.webp,
    alt: 'gold ticket',
  },
  description: 'Gold Ticket in rewards',
};

const baseBenefits = makeBaseBenefits('+50%');

const benefitByKind: Record<
  SpecContractType | PaidSpecContractType,
  Benefit[]
> = {
  Grand: [...baseBenefits, silverTicketBenefit],
  GrandPlus: [...baseBenefits, goldTicketBenefit],
  Golden: [...baseBenefits, silverTicketBenefit],
  GoldenPlus: [...baseBenefits, goldTicketBenefit],
  Blitz: [...baseBenefits, silverTicketBenefit],
  BlitzPlus: [...baseBenefits, goldTicketBenefit],
  Custom: [
    ...makeBaseBenefits('+20%'),
    {
      id: '4',
      icon: {
        img: customizablePng,
        webp: customizableWebp,
        alt: 'customizable',
      },
      description: 'Customizable',
    },
  ],
};

export { benefitByKind };
